import React, {useMemo} from 'react';
import {classes, style} from './doppe-layout7-profile-view-template.st.css';
import {BymoTemplateMetadataInferBymoPageProps} from '../../../doppe-sdk';
import {RatioMaintainer} from '@wix/devzai-utils-react';
import {arrayIsNotNullableOrEmpty, stringIsNotNullableOrWhiteSpace} from '@wix/devzai-utils-common';
import {
    doppeHideableValueGetVisibleValue,
    doppeHideableValueIsVisible
} from '../../../client-server-common/types/doppe-hideable-value';
import {DoppeHideableValueRenderer} from '../../doppe-hideable-value-renderer/doppe-hideable-value-renderer';
import {bymoPageSocialLinkIsHidden, DoppeProfileNameAutoSource} from '../../../client-server-common';
import {
    BymoTemplateSpeedDialTemplateMetadata
} from '../../bymo-templates/bymo-template-speed-dial/bymo-template-speed-dial.metadata';
import {DoppeLayoutRoot} from '../dopp-layouts-components/doppe-layout-root/doppe-layout-root';
import {DoppLayoutContent} from '../dopp-layouts-components/dopp-layout-content/dopp-layout-content';
import {DoppLayoutBackground} from '../dopp-layouts-components/dopp-layout-background/dopp-layout-background';
import {
    DoppLayoutBackgroundMedia
} from '../dopp-layouts-components/dopp-layout-background-media/dopp-layout-background-media';
import {FlexLayout} from '@wix/devzai-common-client';
import {
    DoppePageProfileNameView,
    DoppePageProfileNameViewVerifiedCheckAppearance
} from '../../doppe-page-profile-name-view/doppe-page-profile-name-view';
import {
    DoppePageProfilePictureMediaView
} from '../../doppe-page-profile-picture-media-view/doppe-page-profile-picture-media-view';
import {DoppeLayoutPageContent} from '../dopp-layouts-components/doppe-layout-page-content/doppe-layout-page-content';
import {DoppeLayoutBioText} from '../dopp-layouts-components/doppe-layout-bio-text/doppe-layout-bio-text';
import {DoppeLayoutSocialLinks} from '../dopp-layouts-components/doppe-layout-social-links/doppe-layout-social-links';


export const DoppeLayout7ProfileViewTemplate = React.memo(function DoppeLayout7ProfileViewTemplate(props: BymoTemplateMetadataInferBymoPageProps<typeof BymoTemplateSpeedDialTemplateMetadata>) {
    const {
        profilePictureLinkInBio,
        profilePictureMaskingShape,
        bioText,
        bioTextMaxLines,
        socialLinks,
        profileName,
    } = props;


    const bioTextVisibleValue = doppeHideableValueGetVisibleValue(bioText, '');

    const visibleSocialLinks = socialLinks.filter(socialLink => !bymoPageSocialLinkIsHidden(socialLink));

    const hasProfileImage = useMemo(() => {
        return doppeHideableValueIsVisible(profilePictureLinkInBio);
    }, [profilePictureLinkInBio]);

    const hasProfileTitle = doppeHideableValueIsVisible(profileName);

    const bioAndSocialIcons = (
        <>
            <DoppeLayoutBioText
                className={style(classes.bioText, {})}
                bioText={bioText}
                bioTextMaxLines={bioTextMaxLines}
                lineHeight={'18px'}
            />
            <DoppeLayoutSocialLinks
                className={style(classes.socialLinks, {}) }
                socialLinks={socialLinks}
            />
        </>
    )

    const hasHeaderContent = hasProfileTitle || hasProfileImage || stringIsNotNullableOrWhiteSpace(bioTextVisibleValue) || arrayIsNotNullableOrEmpty(visibleSocialLinks);

    return (
        <DoppeLayoutRoot
            className={style(classes.root, {
                withProfileImage: hasProfileImage,
                hasProfileTitle: hasProfileTitle,
                hasHeaderContent: hasHeaderContent,
            })}
            hideHoppBanner={props.removeHoppBanner}
        >
            <DoppLayoutBackground
                className={style(classes.coverBackground)}
            >
                <DoppLayoutBackgroundMedia
                    className={style(classes.pageWithCoverBackgroundView, {})}
                />
            </DoppLayoutBackground>
            <DoppLayoutContent
                className={style(classes.content)}
            >
                {hasProfileTitle ? (
                    <>
                        <DoppePageProfileNameView
                            className={style(classes.profileName, {})}
                            defaultProfileNameAutoSource={DoppeProfileNameAutoSource.AccountName}
                            verifiedCheckAppearance={DoppePageProfileNameViewVerifiedCheckAppearance.Superscript}
                        />
                        {bioAndSocialIcons}
                    </>
                ) : null}
                {hasProfileImage ? (
                    <div
                        className={style(classes.profileView, FlexLayout.column.alignToCenter)}
                    >
                        <DoppeHideableValueRenderer
                            hideableValue={profilePictureLinkInBio}
                            renderFunction={profilePicture => (
                                <RatioMaintainer
                                    className={style(classes.profileImage, {})}
                                    widthHeightRatio={1}
                                >
                                    <DoppePageProfilePictureMediaView
                                        profilePicture={profilePicture}
                                        layoutSpec={{
                                            widthHeightRatio: 1
                                        }}
                                        maskingShape={profilePictureMaskingShape}
                                        widthSpec={{contentRelativeWidth: 1}}
                                    />
                                </RatioMaintainer>

                            )}
                        />
                    </div>
                ) : null}
                {!hasProfileTitle ? bioAndSocialIcons : null}
                <DoppeLayoutPageContent
                    className={style(classes.pageContent, {})}
                    pageProps={props}
                />
            </DoppLayoutContent>
        </DoppeLayoutRoot>
    )
});

